<template>
  <SfDropdown
    :dropdown-id="dropdownId"
    :is-open="isOpen"
    drawer-direction="left"
    @dropdown-trigger-clicked="handleToggleDropdown"
    @dropdown-closed="handleCloseDropdown"
  >
    <template #trigger>
      {{ triggerLabel }}
    </template>
    <template #menu>
      <SfDropdownItem
        v-if="downloadAsXlsxPath"
        :href="downloadAsXlsxPath"
        @click="handleCloseDropdown"
      >
        {{ downloadLabel }}
      </SfDropdownItem>
      <SfDropdownItem v-if="removePath" @click.stop="confirmRemoval">
        {{ removeLabel }}
      </SfDropdownItem>
    </template>
  </SfDropdown>
</template>

<script setup lang="ts">
import { dropdowns } from '@app/shared/types/dropdown'
import SfDropdown from '@app/shared/vue/components/sf-dropdown/sf-dropdown.vue'
import SfDropdownItem from '@app/shared/vue/components/sf-dropdown/sf-dropdown-item.vue'
import { useDropdown } from '@app/shared/pinia/dropdown'
import { computed } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import SFetch from '@app/utils/sfetch'

defineOptions({
  name: 'PulseTemplateActionsDropdown',
})

interface Props {
  removePath?: string
  downloadAsXlsxPath?: string
}

const props = defineProps<Props>()

const dropdownId = dropdowns.PULSE_TEMPLATE_ACTIONS
const dropdownStore = useDropdown()

function handleCloseDropdown() {
  dropdownStore.closeDropdown()
}

function handleToggleDropdown() {
  dropdownStore.toggleDropdown(dropdownId)
}

const isOpen = computed(() => dropdownStore.currentDropdownId === dropdownId)

const I18n = useI18n()
const downloadLabel = I18n.t('reconciliation_text.actions.download_as_xlsx')
const triggerLabel = I18n.t('reconciliation_proposal.actions.label')
const removeLabel = I18n.t('reconciliation_proposal.actions.remove_all_changes')

function confirmRemoval() {
  dropdownStore.closeDropdown()
  window.sfConfirm({
    question: I18n.t('reconciliation_proposal.confirm.remove'),
    onConfirm: remove,
  })
}

function remove() {
  // don't show the dirty warning when leaving the page
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  Silverfin.Dirty.clearDirty()

  if (props.removePath === undefined) return

  SFetch.raw(props.removePath, { method: 'DELETE' }).then(() =>
    window.Turbolinks.visit(window.location.href)
  )
}
</script>
